<div class="page-title">
  <div [innerHTML]="'Documents.Second.Identity.Title' | translate | safe:'html'" class="title"></div>
  <div [innerHTML]="'Documents.Second.Identity.SubTitle' | translate | safe:'html'" class="sub-title"></div>
</div>
<app-identity-document
  (selectedDocumentChange)="onIdentityDocumentSelect($event)"
  *ngIf="this.identityDocuments"
  [(backDocument)]="user.secondHolder.proofIdentetyBackDocument"
  [(frontDocument)]="user.secondHolder.proofIdentetyDocument"
  [documents]="identityDocuments"
  [remove]="removeDocument.bind(this)"
  [submitted]="submitted"
  [update]="updateDocument.bind(this)"
  [upload]="uploadDocument.bind(this)"
>
</app-identity-document>

<div class="page-title">
  <div [innerHTML]="'Documents.Second.Address.Title' | translate | safe:'html'" class="title"></div>
  <div [innerHTML]="'Documents.Second.Address.SubTitle' | translate | safe:'html'" class="sub-title"></div>
</div>
<app-address-document
  (selectedDocumentChange)="onAddressDocumentSelect($event)"
  *ngIf="this.addressDocuments"
  [(additionalDocument)]="user.secondHolder.proofAddressAdditionalDocument"
  [(backDocument)]="user.secondHolder.proofAddressBackDocument"
  [(frontDocument)]="user.secondHolder.proofAddressDocument"
  [documents]="addressDocuments"
  [remove]="removeDocument.bind(this)"
  [submitted]="submitted"
  [update]="updateDocument.bind(this)"
  [upload]="uploadDocument.bind(this)"
>
</app-address-document>
